var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center"},[(_vm.option.icon)?_c('i',{staticClass:"mr-2",class:_vm.option.icon}):_vm._e(),_vm._v("\n  "+_vm._s(_vm.option.label)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }